import React, { useState, useEffect } from 'react';

function Header({ mode, onModeChange }) {
  const [time, setTime] = useState(new Date());

  useEffect(() => {
    const timer = setInterval(() => setTime(new Date()), 1000);
    return () => clearInterval(timer);
  }, []);

  const formatTime = (d) => d.toLocaleTimeString('en-US', { hour12: false });
  const formatDate = (d) => d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });

  return (
    <header className="app-header">
      <div className="header-left">
        <div className="logo">
          <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
            <rect width="32" height="32" rx="8" fill="#3b82f6"/>
            <path d="M8 16C8 11.6 11.6 8 16 8C20.4 8 24 11.6 24 16C24 20.4 20.4 24 16 24" stroke="white" strokeWidth="2.5" strokeLinecap="round"/>
            <circle cx="16" cy="16" r="3" fill="white"/>
            <path d="M16 24L12 28H20L16 24Z" fill="white"/>
          </svg>
          <div>
            <h1>AI VISION INSPECTOR</h1>
            <span className="subtitle">Safety & Compliance Monitoring System</span>
          </div>
        </div>
      </div>

      <div className="header-right">
        <div className="mode-toggle">
          <span className="mode-label">Sector</span>
          <div className="toggle-buttons">
            <button
              className={`toggle-btn ${mode === 'industry' ? 'active' : ''}`}
              onClick={() => onModeChange('industry')}
            >
              <svg width="14" height="14" viewBox="0 0 16 16" fill="currentColor">
                <path d="M1 14V6l4-4v3l4-3v3l4-3v12H1zm2-2h2v-2H3v2zm4 0h2v-2H7v2zm4 0h2v-2h-2v2z"/>
              </svg>
              Industry
            </button>
            <button
              className={`toggle-btn ${mode === 'public-sector' ? 'active' : ''}`}
              onClick={() => onModeChange('public-sector')}
            >
              <svg width="14" height="14" viewBox="0 0 16 16" fill="currentColor">
                <path d="M8 1l7 4v2H1V5l7-4zM2 8h2v5H2V8zm4 0h2v5H6V8zm4 0h2v5h-2V8zm-9 6h14v2H1v-2z"/>
              </svg>
              Gov / Public
            </button>
          </div>
        </div>

        <div className="header-clock">
          {formatTime(time)} | {formatDate(time)}
        </div>

        <div className="status-badge">
          <span className="status-dot"></span>
          System Online
        </div>
      </div>
    </header>
  );
}

export default Header;
